const common = {
  input: (styles) => ({ ...styles }),
  indicatorSeparator: (styles) => ({
    ...styles,
    width: '0',
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
  }),
  placeholder: (styles) => ({
    ...styles,
    fontSize: '0.8125rem',
  }),
  valueContainer: (styles) => ({
    ...styles,
    flexWrap: 'nowrap',
    padding: '0 8px',
    fontSize: '0.8125rem',
  }),
}

export const customStyles = () => {
  return {
    ...common,
    control: (styles, { isFocused }) => ({
      ...styles,
      borderColor: isFocused
        ? 'rgb(var(--ow-primary-color)) !important'
        : '#dbdfea',
      borderBottomRightRadius: '0',
      borderTopRightRadius: '0',
      borderBottomLeftRadius: isFocused ? '0px' : '4px',
      borderRightWidth: isFocused ? '1px' : '0',
      width: '80px',
      height: '34px',
      minHeight: '34px',
      boxShadow: isFocused
        ? '0 0 0 3px rgba(var(--ow-primary-color),.10)'
        : 'none',
      ':active': {
        ...styles[':active'],
        borderColor: 'rgb(var(--ow-primary-color))',
        borderBottomLeftRadius: '0px',
      },
      ':hover': {
        ...styles[':hover'],
        borderColor: 'rgb(var(--ow-border-color))',
      },
    }),
    menu: (styles) => {
      return {
        ...styles,
        background: '#fff',
        borderRadius: '0 0 2px 2px',
        boxShadow: 'transparent',
        border: '1px solid #b4bdd3',
        marginTop: '0',
        marginBottom: '0',
        zIndex: '1000',
        padding: '6px',
        width: 'auto',
      }
    },
    menuList: (styles) => ({
      ...styles,
      width: 'auto',
      pdddingTop: '0',
    }),
    option: (styles, { isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? '#ebeef2' : '#fff',
        width: 'auto',
        color: '#526484',
        padding: '6px 12px',
        borderRadius: '4px',
        fontSize: '0.8125rem',
        ':active': {
          ...styles[':active'],
          backgroundColor: '#ebeef2',
        },
        whiteSpace: 'nowrap',
      }
    },
  }
}

export const dynamicItemSelectStyles = ({ width }) => {
  return {
    ...common,
    control: (styles, { isFocused }) => ({
      ...styles,
      borderColor: isFocused
        ? 'rgb(var(--ow-primary-color)) !important'
        : '#dbdfea',
      width,
      height: '34px',
      minHeight: '34px',
      boxShadow: isFocused
        ? '0 0 0 3px rgba(var(--ow-primary-color),.10)'
        : 'none',
      ':active': {
        ...styles[':active'],
        borderColor: 'rgb(var(--ow-primary-color))',
      },
      ':hover': {
        ...styles[':hover'],
        borderColor: 'rgb(var(--ow-border-color))',
      },
    }),
    menu: (styles) => {
      return {
        ...styles,
        background: '#fff',
        borderRadius: '0 0 2px 2px',
        boxShadow: 'transparent',
        border: '1px solid #b4bdd3',
        marginTop: '0',
        marginBottom: '0',
        zIndex: '1000',
        padding: '6px',
      }
    },
    menuList: (styles) => ({
      ...styles,
      pdddingTop: '0',
    }),
    option: (styles, { isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? '#ebeef2' : '#fff',
        color: '#526484',
        padding: '6px 12px',
        borderRadius: '4px',
        fontSize: '0.8125rem',
        ':active': {
          ...styles[':active'],
          backgroundColor: '#ebeef2',
        },
        whiteSpace: 'nowrap',
      }
    },
  }
}
